import { useQuery } from '@tanstack/react-query';

import { staffApi } from '../api/staff';

export const useGetRolesById = (roleId: number) => {
  return useQuery({
    queryKey: ['role', roleId],
    queryFn: () => staffApi.getRoleById(roleId),
    enabled: Boolean(roleId),
  });
};
